import { render, staticRenderFns } from "./prize-competition.vue?vue&type=template&id=420793f8&lang=pug"
import script from "./prize-competition.vue?vue&type=script&setup=true&lang=js"
export * from "./prize-competition.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports